import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput,
} from '@material-ui/core';

import {
    resetPassword,
    changeForgotPasswordForm,
    resetForgotPasswordForm
} from '../../vendors/actions/user';
import _isEqual from "lodash/isEqual";
import PasswordInfoWindow from "../../elements/passwordInfoWindow";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import {ClockLoader} from "react-spinners";
import {isMobileBrowser} from '../../vendors/utils/common';

interface MainState {
    user: any,
    form: any,
    apiError: boolean,
    success: boolean
    loading: boolean,
    redirect: any,
    showPassword: boolean,
    showConfirmPassword: boolean
}

interface OwnProps {
    resetPassword?: any,
    changeForgotPasswordForm?: any,
    resetForgotPasswordForm?: any,
    token?: any,
}

interface ConnectStateProps {
    User: any,
    ForgotPasswordForms: any
}

interface ConnectDispatchProps {
    resetForgotPasswordForm: () => void,
    changeForgotPasswordForm: (data: any) => void,
    resetPassword: (data: any) => void,
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


class NewPassword extends React.Component<HeaderProps, MainState> {
    state = {
        user: null,
        apiError: false,
        success: false,
        loading: false,
        showPassword: false,
        showConfirmPassword: false,
        redirect: '',
        form: {
            valid: false,
            newPassword: {
                value: '',
                error: false,
                dirty: false,
                errTypes: {
                    u: false,
                    l: false,
                    n: false,
                    min: false
                }
            },
            confirmPassword: {
                value: '',
                error: false,
                dirty: false,
                errTypes: {
                    u: false,
                    l: false,
                    n: false,
                    min: false
                }
            }
        }
    };


    componentWillUnmount(): void {
        this.props.resetForgotPasswordForm()
    }

    static getDerivedStateFromProps(props: any, state: any) {
        const {ForgotPasswordForms} = props;
        if (ForgotPasswordForms && (!_isEqual(state.form, ForgotPasswordForms.data))) {
            return {
                form: ForgotPasswordForms.data
            };
        }
        return null;
    }

    togglePassword(e: any, type: string) {
        const {showPassword, showConfirmPassword} = this.state;

        if (type === 'showPassword') {
            return this.setState({showPassword: !showPassword})
        }
        this.setState({showConfirmPassword: !showConfirmPassword})
    };

    changeForm(e: any, field: string, validate: boolean = false) {
        const value = e.target.value;
        this.props.changeForgotPasswordForm({value, field, validate});
    };

    validate() {
        const {ForgotPasswordForms} = this.props;
        for (const prop in ForgotPasswordForms.data) {
            if (prop !== 'email') {
                const value = ForgotPasswordForms.data[prop].value;
                this.props.changeForgotPasswordForm({value, field: prop, validate: true});
            }
        }
    }

    async submit() {
        const {ForgotPasswordForms, token} = this.props;

        this.validate();

        if (ForgotPasswordForms.valid && token) {
            this.setState({loading: true});
            const res = await this.props.resetPassword({token, password: ForgotPasswordForms.data.newPassword.value});
            if (res?.error_id) {
                this.setState({
                    apiError: res?.message,
                });
            } else {
                this.setState({success: true});
                setTimeout(() => {
                   return  this.setState({ redirect: "/login" });
                }, 2000)
            }
            this.setState({loading: false});
        }
    };


    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }
        const {
            form,
            success,
            loading
        } = this.state;

        return (
            <Fragment>
                {success && <div>
                    <MuiAlert className="mb-4 mt-4" severity="success">
                        <div className="d-flex align-items-center align-content-center">
                          <span>
                          <strong className="d-block">Successfully reseted.</strong>
                              Your password has been successfully reset, you'll be redirected to the login page in a second.
                          </span>
                        </div>
                    </MuiAlert>
                </div>}
                {!success && (loading ? <div
                    className="d-flex align-items-center justify-content-center clock--loader">
                    <ClockLoader color={'var(--primary)'} loading={true}/>
                </div> : <div>
                    <div className='text-field-custom-mb'>
                        <FormControl
                            fullWidth
                            error={!!form?.newPassword?.error && form?.newPassword?.dirty}
                            onBlur={(e)=> this.changeForm(e, 'newPassword', true)}
                            variant="outlined">
                            <InputLabel htmlFor="newPassword">New Password</InputLabel>
                            {isMobileBrowser() && <PasswordInfoWindow options={{...form?.newPassword?.errTypes}}/>}
                                <OutlinedInput
                                    fullWidth
                                    onChange={(e) => this.changeForm(e, 'newPassword')}
                                    error={!!form?.newPassword?.error && form?.newPassword?.dirty}
                                    id="newPassword"
                                    type={'password'}
                                    labelWidth={100}
                                />
                             {!isMobileBrowser() && <PasswordInfoWindow options={{...form?.newPassword?.errTypes}}/>}
                            {!!form?.newPassword?.error && form?.newPassword?.dirty &&
                            <FormHelperText error={!!form?.newPassword?.error}>{form?.newPassword?.error}</FormHelperText>}
                        </FormControl>
                    </div>
                    <div className='mb-5'>
                        <FormControl
                            fullWidth
                            error={!!form?.confirmPassword?.error && form?.confirmPassword?.dirty}
                            onBlur={(e)=> this.changeForm(e, 'confirmPassword', true)}
                            variant="outlined">
                            <InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
                                <OutlinedInput
                                    fullWidth
                                    onChange={(e) => this.changeForm(e, 'confirmPassword')}
                                    error={!!form?.confirmPassword?.error && form?.confirmPassword?.dirty}
                                    id="confirmPassword"
                                    type={'password'}
                                    labelWidth={120}
                                />
                            {!!form?.confirmPassword?.error && form?.confirmPassword?.dirty &&
                            <FormHelperText error={!!form?.confirmPassword?.error}>{form?.confirmPassword?.error}</FormHelperText>}
                        </FormControl>
                    </div>
                    <div className='button-wrapper'>
                        <Button
                            onClick={() => this.submit()}
                            color="primary"
                            variant="contained"
                            className="and-lawyers-button">
                            Save Password
                        </Button>
                    </div>
                </div>)}

            </Fragment>)
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, ForgotPasswordForms} = state;
    return {
        User,
        ForgotPasswordForms
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        resetForgotPasswordForm: () => dispatch(resetForgotPasswordForm()),
        changeForgotPasswordForm: (data: any) => dispatch(changeForgotPasswordForm(data)),
        resetPassword: (data: any) => dispatch(resetPassword(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPassword);
